<template>
  <!-- prettier-ignore -->
  <modal
    v-model="isOpen"
    @close="resetForm"
  >
    <div class="pin-dialog">

      <h1 v-text="t('cobrowse.title')" />
      <p v-text="t('cobrowse.subtitle')" />

      <Form.Form
        class="pin-dialog__form"
        name="pin-dialog"
        :validator="v"
        @submit="submit"
        @cancel="submit"
      >

        <Form.Input
          v-model="formData.pin"
          autofocus
          autocomplete="do-not-autocomplete"
          name="pin"
          type="password"
          :mask="'######'"
          :max-length="6"
          :delay="0"
          class="pin-dialog__pin"
          :title="t('cobrowse.pin')"
          :placeholder="t('cobrowse.pin')"
          :validate="v.pin"
          theme="dark"
        />

        <Form.Dropdown
          v-model="formData.reason"
          name="reason"
          :title="t('cobrowse.reason')"
          :validate="v.reason"
          :options="reasons"
          theme="dark"
        />

        <Form.Checkbox
          v-model="formData.agb"
          name="agb"
          :validate="v.agb"
          :title="t('cobrowse.agreement')"
        />

        <Form.Button
          primary
          type="submit"
          v-text="t('cobrowse.start')"
        />

      </Form.Form>
    </div>
  </modal>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { events$ } from '@/services'
import * as Form from '@/components/Form'

import Modal from '@/components/Modal/OvpModal'

import { EVENT_COBROWSE } from '@/config/events'
import { computed, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'

import useVuelidate from '@vuelidate/core'
import validations from '@/validations/cobrowse'

// Hooks
const { t, tm } = useI18n()

// Init
const emit = defineEmits(['submit'])

// Data
const isOpen = ref(false)
const formData = reactive({
  pin: null,
  text: null,
  reason: null,
  agb: null,
})
const v = useVuelidate(validations, formData, { $lazy: true })

// Computed
const reasons = computed(() => {
  const items = tm('cobrowse.reasonList')
  if (!Array.isArray(items)) return
  return items.map(item => {
    return {
      text: item,
      value: item,
    }
  })
})

// Methods
function openDialog() {
  isOpen.value = true
  v.value.$reset()
}

function resetForm() {
  Object.assign(formData, {
    pin: null,
    reason: null,
    agb: null,
  })
}

function submit() {
  const { pin, reason } = formData
  emit('submit', { pin, reason })
  isOpen.value = false
  resetForm()
}

// Lifecycle hooks
onMounted(() => {
  events$.on(EVENT_COBROWSE.REQUEST_PIN, openDialog)
})
onBeforeUnmount(() => {
  events$.off(EVENT_COBROWSE.REQUEST_PIN, openDialog)
})
</script>

<style name="mobile" scoped>
.pin-dialog {
  padding: 15px 15px 0 15px;
  color: var(--c-black);
  font-size: 15px;
}

.pin-dialog__form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.pin-dialog__pin {
  width: 200px;
}

.button {
  margin: 20px 0 0 0;
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .button {
    margin: 0;
  }
}
</style>
